export default Object.freeze({
    WATER: 'WaterSample',
    GLYCOL: 'GlycolSample',
    LEGIONELLA_CULTRURE: 'LegionellaCultureSample',
    LEGIONELLOSIS: 'LegionellosisSample',
    DEPOSIT: 'DepositSample',
    COUPON: 'CouponSample',
    CONTENANCE: 'ContenanceSample',
    RESIN: 'ResinSample',
    OTHER: 'OtherSample',
});
